// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CaseWorkflowModel {
    static getAttributeTypeMap() {
        return CaseWorkflowModel.attributeTypeMap;
    }
}
CaseWorkflowModel.discriminator = undefined;
CaseWorkflowModel.additionalProperties = false;
CaseWorkflowModel.attributeTypeMap = [
    {
        "name": "workflowId",
        "baseName": "workflowId",
        "type": "number"
    },
    {
        "name": "tenantId",
        "baseName": "tenantId",
        "type": "number"
    },
    {
        "name": "programId",
        "baseName": "programId",
        "type": "number"
    },
    {
        "name": "accountId",
        "baseName": "accountId",
        "type": "number"
    },
    {
        "name": "displayId",
        "baseName": "displayId",
        "type": "string"
    },
    {
        "name": "typeCode",
        "baseName": "typeCode",
        "type": "string"
    },
    {
        "name": "typeDescription",
        "baseName": "typeDescription",
        "type": "string"
    },
    {
        "name": "statusId",
        "baseName": "statusId",
        "type": "number"
    },
    {
        "name": "statusCode",
        "baseName": "statusCode",
        "type": "string"
    },
    {
        "name": "statusDescription",
        "baseName": "statusDescription",
        "type": "string"
    },
    {
        "name": "subStatusId",
        "baseName": "subStatusId",
        "type": "number"
    },
    {
        "name": "subStatusCode",
        "baseName": "subStatusCode",
        "type": "string"
    },
    {
        "name": "subStatusDescription",
        "baseName": "subStatusDescription",
        "type": "string"
    },
    {
        "name": "isOpen",
        "baseName": "isOpen",
        "type": "boolean"
    },
    {
        "name": "expirationDate",
        "baseName": "expirationDate",
        "type": "Date"
    },
    {
        "name": "endDate",
        "baseName": "endDate",
        "type": "Date"
    },
    {
        "name": "isExpired",
        "baseName": "isExpired",
        "type": "boolean"
    },
    {
        "name": "createdOn",
        "baseName": "createdOn",
        "type": "Date"
    },
    {
        "name": "updatedOn",
        "baseName": "updatedOn",
        "type": "Date"
    },
    {
        "name": "typeCategoryCode",
        "baseName": "typeCategoryCode",
        "type": "string"
    },
    {
        "name": "typeCategoryId",
        "baseName": "typeCategoryId",
        "type": "number"
    },
    {
        "name": "typeCategoryDescription",
        "baseName": "typeCategoryDescription",
        "type": "string"
    },
    {
        "name": "statusCategoryCode",
        "baseName": "statusCategoryCode",
        "type": "string"
    },
    {
        "name": "statusCategoryId",
        "baseName": "statusCategoryId",
        "type": "number"
    },
    {
        "name": "statusCategoryDescription",
        "baseName": "statusCategoryDescription",
        "type": "string"
    },
    {
        "name": "closedBy",
        "baseName": "closedBy",
        "type": "number"
    },
    {
        "name": "addresses",
        "baseName": "addresses",
        "type": ""
    },
    {
        "name": "phoneNumbers",
        "baseName": "phoneNumbers",
        "type": ""
    },
    {
        "name": "workflowCases",
        "baseName": "workflowCases",
        "type": ""
    },
    {
        "name": "sessions",
        "baseName": "sessions",
        "type": ""
    },
    {
        "name": "prescribers",
        "baseName": "prescribers",
        "type": ""
    },
    {
        "name": "prescriptions",
        "baseName": "prescriptions",
        "type": ""
    },
    {
        "name": "sites",
        "baseName": "sites",
        "type": ""
    },
    {
        "name": "payors",
        "baseName": "payors",
        "type": ""
    },
    {
        "name": "pharmacies",
        "baseName": "pharmacies",
        "type": ""
    },
    {
        "name": "homeHealthAgencies",
        "baseName": "homeHealthAgencies",
        "type": ""
    },
    {
        "name": "documents",
        "baseName": "documents",
        "type": ""
    },
    {
        "name": "notes",
        "baseName": "notes",
        "type": ""
    },
    {
        "name": "tasks",
        "baseName": "tasks",
        "type": ""
    },
    {
        "name": "externalIds",
        "baseName": "externalIds",
        "type": ""
    },
    {
        "name": "conditions",
        "baseName": "conditions",
        "type": ""
    },
    {
        "name": "attestations",
        "baseName": "attestations",
        "type": ""
    },
    {
        "name": "contactPreferences",
        "baseName": "contactPreferences",
        "type": ""
    },
    {
        "name": "typeId",
        "baseName": "typeId",
        "type": "number"
    },
    {
        "name": "previousCaseId",
        "baseName": "previousCaseId",
        "type": "number"
    },
    {
        "name": "sourceId",
        "baseName": "sourceId",
        "type": "number"
    },
    {
        "name": "initiatorId",
        "baseName": "initiatorId",
        "type": "number"
    },
    {
        "name": "startDate",
        "baseName": "startDate",
        "type": "Date"
    },
    {
        "name": "assignedUserId",
        "baseName": "assignedUserId",
        "type": "number"
    },
];
//# sourceMappingURL=caseWorkflowModel.js.map